import isEnumValue from '@orderna/admin-panel/src/utils/is-enum-value';

export enum Role {
  SUPER_ADMIN = 'super_admin',
  ADMIN = 'admin',
  MANAGER = 'manager',
  CASHIER = 'cashier',
  KITCHEN = 'kitchen',
}

export const isRole = (value: any) => isEnumValue(Role, value);
